import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { Input } from '@engloba-tech/englobity';
import { isSkeletonLoading } from 'shared';
import { useSelectInputStyles } from './selectInput.styles';

export function SelectInput({ value = '', elements, ...props }) {
  const classes = useSelectInputStyles();

  return (
    <>
      <Input
        isLoading={isSkeletonLoading(value)}
        value={value?.toString()}
        select
        fullWidth
        {...props}
        className={classes.root}
      >
        {elements.map((element, index) => (
          <MenuItem key={index} value={element.value}>
            {element.name}
          </MenuItem>
        ))}
      </Input>
    </>
  );
}

SelectInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      icons: PropTypes.element,
      name: PropTypes.string
    })
  ).isRequired
};
